import { HALApiService } from './../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const templatesService = new CachedService(entities.Orderadmin_Notifications_Entity_Template, '/notifications/templates', HALApiService, createItemsData)
